import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from "react";
import { InfoPanel } from "~/components/AssetModalV2/InfoPanel/components/InfoPanel";
import { usePublicPermissions } from "~/components/PublicPermissionsProvider";
import { canSeeAssetVersions } from "~/utils/permissions/assetPermissions";
export const PublicInfoPanel = /*#__PURE__*/ memo(()=>{
    const { permissions } = usePublicPermissions();
    const canViewVersions = canSeeAssetVersions(permissions);
    const canEdit = false;
    return /*#__PURE__*/ _jsx(InfoPanel, {
        canEdit: canEdit,
        canViewVersions: canViewVersions
    });
});
PublicInfoPanel.displayName = "PublicInfoPanel";
